<script>
import {useStore} from "@/helpers/store-effect";

export default {
  name: "NotificationsCenter",
  template: '#notifications-center-template',
  setup() {
    const store = useStore();

    return {
      get notifications() {
        return store.notifications;
      }
    }
  },
}
</script>
